var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 255,
    viewBox: "0 0 254 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_13344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.706 211.65H170.525C169.031 211.65 167.819 210.438 167.819 208.944V196.426C167.819 194.931 169.03 193.72 170.525 193.72H248.706C250.2 193.72 251.412 194.931 251.412 196.426V208.944C251.412 210.438 250.201 211.65 248.706 211.65Z",
    fill: "url(#paint0_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 211.65H180.449C179.152 211.65 178.099 210.598 178.099 209.3V196.07C178.099 194.772 179.151 193.72 180.449 193.72H238.781C240.079 193.72 241.131 194.772 241.131 196.07V209.3C241.131 210.597 240.079 211.65 238.781 211.65Z",
    fill: "url(#paint1_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 211.65H199.572C198.789 211.65 198.155 211.015 198.155 210.233V195.137C198.155 194.355 198.789 193.72 199.572 193.72H219.659C220.441 193.72 221.076 194.355 221.076 195.137V210.233C221.076 211.015 220.441 211.65 219.659 211.65Z",
    fill: "url(#paint2_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 195.902C171.39 195.902 170.178 197.113 170.178 198.608V211.125C170.178 211.299 170.196 211.468 170.228 211.633C170.325 211.643 170.425 211.65 170.525 211.65H248.706C250.2 211.65 251.412 210.438 251.412 208.944V196.426C251.412 196.252 251.394 196.083 251.362 195.919C251.265 195.908 251.166 195.902 251.065 195.902H172.884Z",
    fill: "url(#paint3_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 193.72H170.525C169.031 193.72 167.819 192.509 167.819 191.014V178.497C167.819 177.002 169.03 175.791 170.525 175.791H248.706C250.2 175.791 251.412 177.002 251.412 178.497V191.014C251.412 192.509 250.201 193.72 248.706 193.72Z",
    fill: "url(#paint4_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 193.72H180.449C179.152 193.72 178.099 192.668 178.099 191.371V178.141C178.099 176.843 179.151 175.791 180.449 175.791H238.781C240.079 175.791 241.131 176.843 241.131 178.141V191.371C241.131 192.668 240.079 193.72 238.781 193.72Z",
    fill: "url(#paint5_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 193.72H199.572C198.789 193.72 198.155 193.086 198.155 192.303V177.208C198.155 176.425 198.789 175.791 199.572 175.791H219.659C220.441 175.791 221.076 176.425 221.076 177.208V192.303C221.076 193.086 220.441 193.72 219.659 193.72Z",
    fill: "url(#paint6_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 177.972C171.39 177.972 170.178 179.184 170.178 180.678V193.196C170.178 193.37 170.196 193.539 170.228 193.703C170.325 193.714 170.425 193.72 170.525 193.72H248.706C250.2 193.72 251.412 192.509 251.412 191.014V178.497C251.412 178.323 251.394 178.154 251.362 177.989C251.265 177.978 251.166 177.972 251.065 177.972H172.884Z",
    fill: "url(#paint7_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 175.791H170.525C169.031 175.791 167.819 174.58 167.819 173.085V160.567C167.819 159.073 169.03 157.861 170.525 157.861H248.706C250.2 157.861 251.412 159.073 251.412 160.567V173.085C251.412 174.58 250.201 175.791 248.706 175.791Z",
    fill: "url(#paint8_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 175.791H180.449C179.152 175.791 178.099 174.739 178.099 173.441V160.211C178.099 158.914 179.151 157.861 180.449 157.861H238.781C240.079 157.861 241.131 158.913 241.131 160.211V173.441C241.131 174.739 240.079 175.791 238.781 175.791Z",
    fill: "url(#paint9_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 175.791H199.572C198.789 175.791 198.155 175.156 198.155 174.374V159.278C198.155 158.496 198.789 157.861 199.572 157.861H219.659C220.441 157.861 221.076 158.496 221.076 159.278V174.374C221.076 175.156 220.441 175.791 219.659 175.791Z",
    fill: "url(#paint10_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 160.043C171.39 160.043 170.178 161.254 170.178 162.749V175.266C170.178 175.44 170.196 175.61 170.228 175.774C170.325 175.784 170.425 175.791 170.525 175.791H248.706C250.2 175.791 251.412 174.58 251.412 173.085V160.567C251.412 160.393 251.394 160.224 251.362 160.06C251.265 160.049 251.166 160.043 251.065 160.043H172.884Z",
    fill: "url(#paint11_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 157.861H170.525C169.031 157.861 167.819 156.65 167.819 155.156V142.638C167.819 141.143 169.03 139.932 170.525 139.932H248.706C250.2 139.932 251.412 141.143 251.412 142.638V155.156C251.412 156.65 250.201 157.861 248.706 157.861Z",
    fill: "url(#paint12_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 157.861H180.449C179.152 157.861 178.099 156.81 178.099 155.512V142.282C178.099 140.984 179.151 139.932 180.449 139.932H238.781C240.079 139.932 241.131 140.984 241.131 142.282V155.512C241.131 156.81 240.079 157.861 238.781 157.861Z",
    fill: "url(#paint13_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 157.861H199.572C198.789 157.861 198.155 157.227 198.155 156.445V141.349C198.155 140.567 198.789 139.932 199.572 139.932H219.659C220.441 139.932 221.076 140.567 221.076 141.349V156.445C221.076 157.227 220.441 157.861 219.659 157.861Z",
    fill: "url(#paint14_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 142.113C171.39 142.113 170.178 143.325 170.178 144.819V157.337C170.178 157.511 170.196 157.68 170.228 157.845C170.325 157.855 170.425 157.861 170.525 157.861H248.706C250.2 157.861 251.412 156.65 251.412 155.156V142.638C251.412 142.464 251.394 142.295 251.362 142.13C251.265 142.119 251.166 142.113 251.065 142.113H172.884Z",
    fill: "url(#paint15_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 139.932H170.525C169.031 139.932 167.819 138.721 167.819 137.226V124.708C167.819 123.214 169.03 122.003 170.525 122.003H248.706C250.2 122.003 251.412 123.214 251.412 124.708V137.226C251.412 138.721 250.201 139.932 248.706 139.932Z",
    fill: "url(#paint16_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 139.932H180.449C179.152 139.932 178.099 138.88 178.099 137.582V124.352C178.099 123.054 179.151 122.003 180.449 122.003H238.781C240.079 122.003 241.131 123.054 241.131 124.352V137.582C241.131 138.88 240.079 139.932 238.781 139.932Z",
    fill: "url(#paint17_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 139.932H199.572C198.789 139.932 198.155 139.298 198.155 138.515V123.42C198.155 122.637 198.789 122.003 199.572 122.003H219.659C220.441 122.003 221.076 122.637 221.076 123.42V138.515C221.076 139.298 220.441 139.932 219.659 139.932Z",
    fill: "url(#paint18_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 124.184C171.39 124.184 170.178 125.395 170.178 126.89V139.408C170.178 139.581 170.196 139.751 170.228 139.915C170.325 139.926 170.425 139.932 170.525 139.932H248.706C250.2 139.932 251.412 138.721 251.412 137.226V124.709C251.412 124.535 251.394 124.365 251.362 124.201C251.265 124.191 251.166 124.184 251.065 124.184H172.884Z",
    fill: "url(#paint19_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 122.003H170.525C169.031 122.003 167.819 120.791 167.819 119.297V106.779C167.819 105.284 169.03 104.073 170.525 104.073H248.706C250.2 104.073 251.412 105.284 251.412 106.779V119.297C251.412 120.791 250.201 122.003 248.706 122.003Z",
    fill: "url(#paint20_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 122.003H180.449C179.152 122.003 178.099 120.951 178.099 119.653V106.423C178.099 105.126 179.151 104.073 180.449 104.073H238.781C240.079 104.073 241.131 105.125 241.131 106.423V119.653C241.131 120.951 240.079 122.003 238.781 122.003Z",
    fill: "url(#paint21_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 122.003H199.572C198.789 122.003 198.155 121.368 198.155 120.586V105.49C198.155 104.708 198.789 104.073 199.572 104.073H219.659C220.441 104.073 221.076 104.708 221.076 105.49V120.586C221.076 121.369 220.441 122.003 219.659 122.003Z",
    fill: "url(#paint22_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 106.255C171.39 106.255 170.178 107.466 170.178 108.96V121.478C170.178 121.652 170.196 121.821 170.228 121.986C170.325 121.996 170.425 122.003 170.525 122.003H248.706C250.2 122.003 251.412 120.791 251.412 119.297V106.779C251.412 106.605 251.394 106.436 251.362 106.272C251.265 106.261 251.166 106.255 251.065 106.255H172.884Z",
    fill: "url(#paint23_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 104.074H170.525C169.031 104.074 167.819 102.862 167.819 101.368V88.8501C167.819 87.3555 169.03 86.1443 170.525 86.1443H248.706C250.2 86.1443 251.412 87.3555 251.412 88.8501V101.368C251.412 102.862 250.201 104.074 248.706 104.074Z",
    fill: "url(#paint24_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 104.074H180.449C179.152 104.074 178.099 103.022 178.099 101.724V88.4935C178.099 87.1961 179.151 86.1438 180.449 86.1438H238.781C240.079 86.1438 241.131 87.1957 241.131 88.4935V101.723C241.131 103.021 240.079 104.074 238.781 104.074Z",
    fill: "url(#paint25_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 104.074H199.572C198.789 104.074 198.155 103.439 198.155 102.657V87.5612C198.155 86.7788 198.789 86.1443 199.572 86.1443H219.659C220.441 86.1443 221.076 86.7788 221.076 87.5612V102.657C221.076 103.439 220.441 104.074 219.659 104.074Z",
    fill: "url(#paint26_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 88.3252C171.39 88.3252 170.178 89.5364 170.178 91.031V103.549C170.178 103.723 170.196 103.892 170.228 104.056C170.325 104.067 170.425 104.073 170.525 104.073H248.706C250.2 104.073 251.412 102.862 251.412 101.367V88.8496C251.412 88.6758 251.394 88.5065 251.362 88.3421C251.265 88.3317 251.166 88.3252 251.065 88.3252H172.884Z",
    fill: "url(#paint27_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 86.1443H170.525C169.031 86.1443 167.819 84.9331 167.819 83.4385V70.9208C167.819 69.4261 169.03 68.2149 170.525 68.2149H248.706C250.2 68.2149 251.412 69.4261 251.412 70.9208V83.4385C251.412 84.9326 250.201 86.1443 248.706 86.1443Z",
    fill: "url(#paint28_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.781 86.1443H180.449C179.152 86.1443 178.099 85.0925 178.099 83.7946V70.5647C178.099 69.2673 179.151 68.2149 180.449 68.2149H238.781C240.079 68.2149 241.131 69.2668 241.131 70.5647V83.7946C241.131 85.0925 240.079 86.1443 238.781 86.1443Z",
    fill: "url(#paint29_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 86.1443H199.572C198.789 86.1443 198.155 85.5098 198.155 84.7274V69.6318C198.155 68.8494 198.789 68.2149 199.572 68.2149H219.659C220.441 68.2149 221.076 68.8494 221.076 69.6318V84.7274C221.076 85.5098 220.441 86.1443 219.659 86.1443Z",
    fill: "url(#paint30_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.884 70.3963C171.39 70.3963 170.178 71.6075 170.178 73.1021V85.6199C170.178 85.7937 170.196 85.9625 170.228 86.1274C170.325 86.1378 170.425 86.1443 170.525 86.1443H248.706C250.2 86.1443 251.412 84.9331 251.412 83.4385V70.9207C251.412 70.7469 251.394 70.5776 251.362 70.4132C251.265 70.4028 251.166 70.3963 251.065 70.3963H172.884Z",
    fill: "url(#paint31_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.027 133.812L200.843 96.133C195.484 68.0286 170.91 47.6977 142.299 47.6977H115.343C86.7325 47.6977 62.1587 68.0286 56.7998 96.133L52.7264 117.495C48.8118 138.025 42.5544 158.109 33.1962 176.795C30.46 182.259 29.0232 188.485 29.2926 195.072C30.071 214.13 46.8435 230.528 65.9134 230.901C66.0534 230.904 66.1928 230.906 66.3323 230.907C74.9842 230.982 83.3144 234.354 89.382 240.522C96.1633 247.416 105.596 251.692 116.032 251.692C128.696 251.692 139.887 245.395 146.653 235.764C148.83 232.663 152.402 230.901 156.192 230.908H156.258C157.886 230.908 159.486 230.788 161.049 230.556C163.997 230.119 166.98 230.872 169.414 232.593C175.997 237.249 184.147 239.834 192.922 239.389C211.7 238.439 227.018 223.407 228.294 204.649C228.753 197.899 227.418 191.502 224.719 185.883C216.799 169.391 211.454 151.782 208.027 133.812Z",
    fill: "url(#paint32_radial_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6625 230.908C87.3192 230.908 104.065 214.162 104.065 193.506C104.065 172.849 87.3192 156.103 66.6625 156.103C46.0058 156.103 29.2603 172.849 29.2603 193.506C29.2603 214.162 46.0058 230.908 66.6625 230.908Z",
    fill: "url(#paint33_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.032 251.691C136.688 251.691 153.434 234.946 153.434 214.289C153.434 193.632 136.688 176.887 116.032 176.887C95.375 176.887 78.6294 193.632 78.6294 214.289C78.6294 234.946 95.375 251.691 116.032 251.691Z",
    fill: "url(#paint34_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.98 239.439C211.637 239.439 228.382 222.693 228.382 202.037C228.382 181.38 211.637 164.634 190.98 164.634C170.323 164.634 153.578 181.38 153.578 202.037C153.578 222.693 170.323 239.439 190.98 239.439Z",
    fill: "url(#paint35_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.293 204.649C228.752 197.899 227.417 191.502 224.719 185.883C216.799 169.391 211.454 151.782 208.028 133.811L200.843 96.1325C198.898 85.9346 194.414 76.7692 188.135 69.2179C177.743 60.6133 164.441 55.5248 150.127 55.5248H123.171C94.5603 55.5248 69.986 75.8558 64.6271 103.96L60.5536 125.323C56.6391 145.852 50.3817 165.936 41.0235 184.622C38.2873 190.086 36.8505 196.312 37.1194 202.899C37.4257 210.397 40.2152 217.478 44.6388 223.338C50.7263 227.923 58.1272 230.748 65.913 230.9C66.053 230.903 66.1924 230.905 66.3319 230.906C74.9838 230.981 83.3145 234.353 89.3822 240.521C96.1635 247.415 105.596 251.691 116.032 251.691C128.696 251.691 139.887 245.394 146.653 235.763C148.831 232.662 152.403 230.9 156.192 230.907H156.258C157.886 230.907 159.486 230.787 161.049 230.555C163.997 230.118 166.98 230.871 169.414 232.592C175.997 237.248 184.148 239.833 192.922 239.388C211.7 238.439 227.018 223.407 228.293 204.649Z",
    fill: "url(#paint36_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.552 91.7263C147.844 90.8886 145.271 90.2855 142.834 89.9135C141.659 89.7337 140.472 89.5883 139.275 89.4737C139.265 89.4682 139.255 89.4627 139.246 89.4573L133.763 83.7786C132.68 83.0719 131.506 82.7163 130.243 82.7163C128.797 82.7163 127.579 83.053 126.587 83.7214C125.593 84.3917 125.098 85.1876 125.098 86.1055V89.6211C117.245 90.7253 110.768 93.6259 105.67 98.3199C100.569 103.014 98.0206 109.456 98.0206 117.647C98.0206 120.987 98.6068 124.034 99.7802 126.786C100.953 129.54 102.307 131.795 103.843 133.555L125.099 154.83V167.47C121.578 166.84 117.741 165.056 113.591 162.122C109.438 159.19 106.504 157.722 104.79 157.722C102.353 157.722 100.209 158.987 98.3588 161.513C96.5081 164.041 95.5837 166.569 95.5837 169.095C95.5837 172.387 97.1989 175.428 100.424 178.22L153.428 231.224C154.324 231.014 155.252 230.906 156.193 230.908H156.259C157.887 230.908 159.487 230.788 161.05 230.556C163.998 230.119 166.981 230.872 169.415 232.593C175.998 237.249 184.149 239.834 192.923 239.389C211.701 238.439 227.019 223.407 228.295 204.649C228.754 197.899 227.419 191.502 224.72 185.883C219.209 174.405 214.947 162.386 211.708 150.08L157.118 95.492C155.447 93.8186 153.26 92.564 150.552 91.7263Z",
    fill: "url(#paint37_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.368 147.027C159.237 144.139 157.884 141.746 156.306 139.851C154.725 137.956 152.627 136.151 150.009 134.436C147.391 132.722 145.045 131.413 142.969 130.51C140.892 129.608 138.366 128.57 135.388 127.395V107.628C138.637 107.899 141.772 108.802 144.797 110.336C147.821 111.872 149.964 112.638 151.229 112.638C153.845 112.638 155.9 111.354 157.389 108.786C158.878 106.217 159.623 103.738 159.623 101.352C159.623 99.1202 158.787 97.1679 157.118 95.492C155.447 93.8186 153.26 92.5645 150.552 91.7263C147.844 90.8886 145.271 90.2855 142.834 89.9135C140.397 89.5409 137.914 89.3084 135.388 89.2152V86.0905C135.388 85.2568 134.846 84.4868 133.763 83.7781C132.68 83.0714 131.506 82.7163 130.243 82.7163C128.797 82.7163 127.579 83.053 126.587 83.7214C125.593 84.3917 125.098 85.1876 125.098 86.1055V89.6211C117.245 90.7253 110.768 93.6259 105.67 98.3199C100.569 103.014 98.0206 109.456 98.0206 117.647C98.0206 120.987 98.6063 124.034 99.7802 126.786C100.953 129.54 102.307 131.795 103.843 133.555C105.376 135.315 107.543 137.031 110.341 138.7C113.138 140.371 115.486 141.611 117.381 142.423C119.277 143.235 121.849 144.274 125.099 145.537V167.47C121.578 166.84 117.741 165.056 113.591 162.122C109.438 159.19 106.504 157.722 104.79 157.722C102.353 157.722 100.209 158.987 98.3588 161.513C96.5081 164.041 95.5837 166.569 95.5837 169.095C95.5837 173.519 98.4948 177.489 104.316 181.01C110.138 184.53 117.064 186.426 125.099 186.696V190.081C125.099 191.073 125.594 191.929 126.588 192.653C127.58 193.374 128.798 193.736 130.243 193.736C131.506 193.736 132.681 193.351 133.763 192.585C134.847 191.817 135.389 190.982 135.389 190.081V186.154C143.512 184.8 149.987 181.598 154.817 176.541C159.645 171.487 162.06 164.853 162.06 156.639C162.06 153.119 161.495 149.916 160.368 147.027ZM126.452 124.146C120.675 121.709 117.787 118.865 117.787 115.616C117.787 111.737 120.674 109.209 126.452 108.034V124.146ZM134.034 167.335V149.193C139.538 151.812 142.293 155.015 142.293 158.806C142.293 163.229 139.538 166.072 134.034 167.335Z",
    fill: "url(#paint38_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.192 47.6972H110.451L93.7355 15.6533C91.2677 10.923 94.0852 5.15468 99.333 4.19247L110.279 2.18537C122.539 -0.062279 135.104 -0.062279 147.363 2.18537L158.309 4.19247C163.557 5.15468 166.375 10.9225 163.907 15.6533L147.192 47.6972Z",
    fill: "url(#paint39_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.931 47.6972H122.711L117.152 15.6533C116.332 10.923 117.269 5.15468 119.014 4.19247L122.655 2.18537C126.732 -0.062279 130.911 -0.062279 134.988 2.18537L138.629 4.19247C140.374 5.15468 141.311 10.9225 140.49 15.6533L134.931 47.6972Z",
    fill: "url(#paint40_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.355 7.41724C164.071 8.43623 163.711 9.85614 162.599 10.4194C157.386 13.0705 151.222 13.0705 146.01 10.4194L141.401 8.07964C136.189 5.42857 130.024 5.42857 124.812 8.07964L120.209 10.4194C114.996 13.0705 108.832 13.0705 103.619 10.4194L98.7986 7.96758C97.1098 7.10846 97.4245 4.55402 99.2867 4.20439C99.3026 4.2014 99.3181 4.19842 99.334 4.19543L110.28 2.18434C122.537 -0.0598207 135.105 -0.0598207 147.362 2.18434L158.309 4.19543C160.47 4.58938 162.217 5.79862 163.355 7.41724Z",
    fill: "url(#paint41_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.013 11.9086C164.259 11.3114 164.438 10.6989 164.569 10.0813C163.849 7.20561 161.543 4.78563 158.31 4.19247L147.363 2.18537C135.104 -0.062279 122.538 -0.062279 110.28 2.18537L102.115 3.68248C101.092 6.13333 100.962 9.17336 102.089 11.9086L116.84 47.6972H147.192L157.059 28.7812L164.013 11.9086Z",
    fill: "url(#paint42_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.821 51.2896C120.857 51.2896 113.319 50.7751 107.141 49.8243C105.107 49.5111 103.742 47.5717 104.153 45.5546C104.534 43.679 106.316 42.4304 108.208 42.7203C114.01 43.6098 121.309 44.1078 128.821 44.1078C136.333 44.1078 143.632 43.6098 149.435 42.7203C151.327 42.4304 153.109 43.6785 153.49 45.5546C153.901 47.5717 152.536 49.5116 150.502 49.8243C144.324 50.7751 136.786 51.2896 128.821 51.2896Z",
    fill: "url(#paint43_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0956 149C85.8103 147.811 84.7514 146.924 83.4755 146.924H73.551H54.4283H45.2903C42.0112 157.165 38.0179 167.166 33.1959 176.795C30.4597 182.258 29.0228 188.485 29.2918 195.072C30.0702 214.129 46.8432 230.528 65.9131 230.901C66.053 230.903 66.1925 230.905 66.3319 230.907C74.9839 230.982 83.3146 234.353 89.3822 240.522C96.1635 247.415 105.596 251.691 116.032 251.691C128.696 251.691 139.887 245.395 146.653 235.763C148.831 232.663 152.403 230.9 156.192 230.908H156.258C157.886 230.908 159.486 230.787 161.049 230.555C163.997 230.119 166.98 230.871 169.414 232.592C169.694 232.79 169.979 232.979 170.265 233.169L86.0956 149Z",
    fill: "url(#paint44_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4754 254.5H5.29423C3.80011 254.5 2.58838 253.289 2.58838 251.794V239.276C2.58838 237.782 3.79961 236.571 5.29423 236.571H83.4754C84.9695 236.571 86.1813 237.782 86.1813 239.276V251.794C86.1813 253.289 84.9695 254.5 83.4754 254.5Z",
    fill: "url(#paint45_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.551 254.5H15.2186C13.9208 254.5 12.8689 253.448 12.8689 252.15V238.92C12.8689 237.623 13.9208 236.571 15.2186 236.571H73.551C74.8484 236.571 75.9007 237.622 75.9007 238.92V252.15C75.9007 253.448 74.8489 254.5 73.551 254.5Z",
    fill: "url(#paint46_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4282 254.5H34.3412C33.5588 254.5 32.9243 253.866 32.9243 253.083V237.988C32.9243 237.205 33.5588 236.571 34.3412 236.571H54.4282C55.2106 236.571 55.8451 237.205 55.8451 237.988V253.083C55.8451 253.866 55.2106 254.5 54.4282 254.5Z",
    fill: "url(#paint47_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65336 238.752C6.15874 238.752 4.94751 239.963 4.94751 241.458V253.976C4.94751 254.149 4.96544 254.319 4.99682 254.483C5.09443 254.494 5.19354 254.5 5.29415 254.5H83.4753C84.97 254.5 86.1812 253.289 86.1812 251.794V239.276C86.1812 239.103 86.1633 238.933 86.1319 238.769C86.0343 238.758 85.9352 238.752 85.8346 238.752H7.65336Z",
    fill: "url(#paint48_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4754 236.571H5.29423C3.80011 236.571 2.58838 235.359 2.58838 233.865V221.347C2.58838 219.852 3.79961 218.641 5.29423 218.641H83.4754C84.9695 218.641 86.1813 219.852 86.1813 221.347V233.865C86.1813 235.359 84.9695 236.571 83.4754 236.571Z",
    fill: "url(#paint49_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.551 236.571H15.2186C13.9208 236.571 12.8689 235.519 12.8689 234.221V220.99C12.8689 219.693 13.9208 218.641 15.2186 218.641H73.551C74.8484 218.641 75.9007 219.693 75.9007 220.99V234.221C75.9007 235.519 74.8489 236.571 73.551 236.571Z",
    fill: "url(#paint50_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4282 236.571H34.3412C33.5588 236.571 32.9243 235.936 32.9243 235.154V220.058C32.9243 219.276 33.5588 218.641 34.3412 218.641H54.4282C55.2106 218.641 55.8451 219.276 55.8451 220.058V235.154C55.8451 235.936 55.2106 236.571 54.4282 236.571Z",
    fill: "url(#paint51_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65336 220.823C6.15874 220.823 4.94751 222.034 4.94751 223.528V236.046C4.94751 236.22 4.96544 236.389 4.99682 236.554C5.09443 236.565 5.19354 236.571 5.29415 236.571H83.4753C84.97 236.571 86.1812 235.359 86.1812 233.865V221.347C86.1812 221.173 86.1633 221.004 86.1319 220.84C86.0343 220.829 85.9352 220.823 85.8346 220.823H7.65336Z",
    fill: "url(#paint52_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4754 218.641H5.29423C3.80011 218.641 2.58838 217.43 2.58838 215.935V203.418C2.58838 201.924 3.79961 200.712 5.29423 200.712H83.4754C84.9695 200.712 86.1813 201.923 86.1813 203.418V215.935C86.1813 217.43 84.9695 218.641 83.4754 218.641Z",
    fill: "url(#paint53_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.551 218.641H15.2186C13.9208 218.641 12.8689 217.589 12.8689 216.291V203.062C12.8689 201.764 13.9208 200.712 15.2186 200.712H73.551C74.8484 200.712 75.9007 201.764 75.9007 203.062V216.291C75.9007 217.589 74.8489 218.641 73.551 218.641Z",
    fill: "url(#paint54_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4282 218.641H34.3412C33.5588 218.641 32.9243 218.007 32.9243 217.224V202.129C32.9243 201.346 33.5588 200.712 34.3412 200.712H54.4282C55.2106 200.712 55.8451 201.346 55.8451 202.129V217.224C55.8451 218.007 55.2106 218.641 54.4282 218.641Z",
    fill: "url(#paint55_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65336 202.893C6.15874 202.893 4.94751 204.104 4.94751 205.599V218.117C4.94751 218.291 4.96544 218.46 4.99682 218.624C5.09443 218.635 5.19354 218.641 5.29415 218.641H83.4753C84.97 218.641 86.1812 217.43 86.1812 215.935V203.418C86.1812 203.244 86.1633 203.075 86.1319 202.91C86.0343 202.9 85.9352 202.893 85.8346 202.893H7.65336Z",
    fill: "url(#paint56_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4754 200.712H5.29423C3.80011 200.712 2.58838 199.501 2.58838 198.006V185.488C2.58838 183.994 3.79961 182.782 5.29423 182.782H83.4754C84.9695 182.782 86.1813 183.994 86.1813 185.488V198.006C86.1813 199.501 84.9695 200.712 83.4754 200.712Z",
    fill: "url(#paint57_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.551 200.712H15.2186C13.9208 200.712 12.8689 199.66 12.8689 198.362V185.132C12.8689 183.834 13.9208 182.782 15.2186 182.782H73.551C74.8484 182.782 75.9007 183.834 75.9007 185.132V198.362C75.9007 199.66 74.8489 200.712 73.551 200.712Z",
    fill: "url(#paint58_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4282 200.712H34.3412C33.5588 200.712 32.9243 200.077 32.9243 199.295V184.199C32.9243 183.417 33.5588 182.782 34.3412 182.782H54.4282C55.2106 182.782 55.8451 183.417 55.8451 184.199V199.295C55.8451 200.078 55.2106 200.712 54.4282 200.712Z",
    fill: "url(#paint59_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65336 184.964C6.15874 184.964 4.94751 186.175 4.94751 187.67V200.187C4.94751 200.361 4.96544 200.53 4.99682 200.695C5.09443 200.706 5.19354 200.712 5.29415 200.712H83.4753C84.97 200.712 86.1812 199.501 86.1812 198.006V185.488C86.1812 185.314 86.1633 185.146 86.1319 184.981C86.0343 184.97 85.9352 184.964 85.8346 184.964H7.65336Z",
    fill: "url(#paint60_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4754 182.783H5.29423C3.80011 182.783 2.58838 181.572 2.58838 180.077V167.559C2.58838 166.065 3.79961 164.853 5.29423 164.853H83.4754C84.9695 164.853 86.1813 166.065 86.1813 167.559V180.077C86.1813 181.571 84.9695 182.783 83.4754 182.783Z",
    fill: "url(#paint61_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.551 182.783H15.2186C13.9208 182.783 12.8689 181.731 12.8689 180.433V167.203C12.8689 165.906 13.9208 164.853 15.2186 164.853H73.551C74.8484 164.853 75.9007 165.905 75.9007 167.203V180.433C75.9007 181.731 74.8489 182.783 73.551 182.783Z",
    fill: "url(#paint62_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4282 182.783H34.3412C33.5588 182.783 32.9243 182.148 32.9243 181.366V166.27C32.9243 165.488 33.5588 164.853 34.3412 164.853H54.4282C55.2106 164.853 55.8451 165.488 55.8451 166.27V181.366C55.8451 182.148 55.2106 182.783 54.4282 182.783Z",
    fill: "url(#paint63_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65336 167.034C6.15874 167.034 4.94751 168.246 4.94751 169.74V182.258C4.94751 182.432 4.96544 182.601 4.99682 182.765C5.09443 182.776 5.19354 182.782 5.29415 182.782H83.4753C84.97 182.782 86.1812 181.571 86.1812 180.077V167.559C86.1812 167.385 86.1633 167.216 86.1319 167.051C86.0343 167.041 85.9352 167.034 85.8346 167.034H7.65336Z",
    fill: "url(#paint64_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4754 164.853H5.29423C3.80011 164.853 2.58838 163.642 2.58838 162.148V149.63C2.58838 148.135 3.79961 146.924 5.29423 146.924H83.4754C84.9695 146.924 86.1813 148.135 86.1813 149.63V162.148C86.1813 163.642 84.9695 164.853 83.4754 164.853Z",
    fill: "url(#paint65_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.551 164.853H15.2186C13.9208 164.853 12.8689 163.802 12.8689 162.504V149.273C12.8689 147.976 13.9208 146.924 15.2186 146.924H73.551C74.8484 146.924 75.9007 147.975 75.9007 149.273V162.504C75.9007 163.802 74.8489 164.853 73.551 164.853Z",
    fill: "url(#paint66_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4282 164.853H34.3412C33.5588 164.853 32.9243 164.219 32.9243 163.437V148.341C32.9243 147.559 33.5588 146.924 34.3412 146.924H54.4282C55.2106 146.924 55.8451 147.559 55.8451 148.341V163.437C55.8451 164.219 55.2106 164.853 54.4282 164.853Z",
    fill: "url(#paint67_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65336 149.105C6.15874 149.105 4.94751 150.317 4.94751 151.811V164.329C4.94751 164.503 4.96544 164.672 4.99682 164.837C5.09443 164.847 5.19354 164.853 5.29415 164.853H83.4753C84.97 164.853 86.1812 163.642 86.1812 162.148V149.63C86.1812 149.456 86.1633 149.287 86.1319 149.122C86.0343 149.112 85.9352 149.105 85.8346 149.105H7.65336Z",
    fill: "url(#paint68_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.071 254.5H151.889C150.395 254.5 149.184 253.289 149.184 251.794V239.276C149.184 237.782 150.395 236.571 151.889 236.571H230.071C231.565 236.571 232.776 237.782 232.776 239.276V251.794C232.776 253.289 231.565 254.5 230.071 254.5Z",
    fill: "url(#paint69_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.146 254.5H161.814C160.516 254.5 159.464 253.448 159.464 252.15V238.92C159.464 237.623 160.516 236.571 161.814 236.571H220.146C221.444 236.571 222.496 237.622 222.496 238.92V252.15C222.496 253.448 221.444 254.5 220.146 254.5Z",
    fill: "url(#paint70_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.024 254.5H180.937C180.154 254.5 179.52 253.866 179.52 253.083V237.988C179.52 237.205 180.154 236.571 180.937 236.571H201.024C201.806 236.571 202.441 237.205 202.441 237.988V253.083C202.441 253.866 201.806 254.5 201.024 254.5Z",
    fill: "url(#paint71_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.249 238.752C152.755 238.752 151.543 239.963 151.543 241.458V253.976C151.543 254.149 151.561 254.319 151.592 254.483C151.69 254.494 151.789 254.5 151.89 254.5H230.071C231.565 254.5 232.777 253.289 232.777 251.794V239.276C232.777 239.103 232.759 238.933 232.727 238.769C232.63 238.758 232.531 238.752 232.43 238.752H154.249Z",
    fill: "url(#paint72_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.071 236.571H151.889C150.395 236.571 149.184 235.359 149.184 233.865V221.347C149.184 219.852 150.395 218.641 151.889 218.641H230.071C231.565 218.641 232.776 219.852 232.776 221.347V233.865C232.776 235.359 231.565 236.571 230.071 236.571Z",
    fill: "url(#paint73_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.146 236.571H161.814C160.516 236.571 159.464 235.519 159.464 234.221V220.99C159.464 219.693 160.516 218.641 161.814 218.641H220.146C221.444 218.641 222.496 219.693 222.496 220.99V234.221C222.496 235.519 221.444 236.571 220.146 236.571Z",
    fill: "url(#paint74_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.024 236.571H180.937C180.154 236.571 179.52 235.936 179.52 235.154V220.058C179.52 219.276 180.154 218.641 180.937 218.641H201.024C201.806 218.641 202.441 219.276 202.441 220.058V235.154C202.441 235.936 201.806 236.571 201.024 236.571Z",
    fill: "url(#paint75_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.249 220.823C152.755 220.823 151.543 222.034 151.543 223.528V236.046C151.543 236.22 151.561 236.389 151.592 236.554C151.69 236.565 151.789 236.571 151.89 236.571H230.071C231.565 236.571 232.777 235.359 232.777 233.865V221.347C232.777 221.173 232.759 221.004 232.727 220.84C232.63 220.829 232.531 220.823 232.43 220.823H154.249Z",
    fill: "url(#paint76_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.345 104.928C38.8675 109.801 32.4876 116.219 27.6561 123.728C26.5694 125.417 24.0623 125.412 22.982 123.72C18.1779 116.194 11.8214 109.752 4.36181 104.852C2.70583 103.764 2.71031 101.292 4.37028 100.21C11.8478 95.3371 18.2277 88.9189 23.0592 81.4104C24.1454 79.7221 26.6531 79.7266 27.7333 81.4189C32.5374 88.9448 38.8939 95.3864 46.354 100.287C48.0095 101.374 48.005 103.847 46.345 104.928Z",
    fill: "url(#paint77_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1299 37.1014C70.8422 40.5474 66.3304 45.086 62.9139 50.3961C62.1454 51.5899 60.3724 51.5869 59.6084 50.3901C56.2113 45.0681 51.716 40.513 46.4408 37.0476C45.2699 36.2787 45.2729 34.5295 46.4467 33.7646C51.7344 30.3186 56.2462 25.78 59.6627 20.4699C60.4312 19.2761 62.2042 19.2791 62.9682 20.4759C66.3653 25.7979 70.8606 30.353 76.1358 33.8184C77.3067 34.5878 77.3037 36.3364 76.1299 37.1014Z",
    fill: "url(#paint78_linear_1176_13344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.749 49.3656C214.462 52.8115 209.95 57.3501 206.533 62.6602C205.765 63.854 203.992 63.8511 203.228 62.6543C199.831 57.3322 195.335 52.7772 190.06 49.3118C188.889 48.5428 188.892 46.7937 190.066 46.0287C195.354 42.5828 199.866 38.0442 203.282 32.7341C204.051 31.5403 205.824 31.5433 206.588 32.74C209.985 38.0621 214.48 42.6172 219.755 46.0825C220.926 46.852 220.923 48.6006 219.749 49.3656Z",
    fill: "url(#paint79_linear_1176_13344)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1176_13344",
    x1: 209.615,
    y1: 194.09,
    x2: 209.615,
    y2: 217.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1176_13344",
    x1: 209.615,
    y1: 194.426,
    x2: 209.615,
    y2: 233.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1176_13344",
    x1: 209.615,
    y1: 194.426,
    x2: 209.615,
    y2: 233.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1176_13344",
    x1: 209.519,
    y1: 200.69,
    x2: 200.25,
    y2: 178.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1176_13344",
    x1: 209.615,
    y1: 176.16,
    x2: 209.615,
    y2: 199.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1176_13344",
    x1: 209.615,
    y1: 176.498,
    x2: 209.615,
    y2: 215.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1176_13344",
    x1: 209.615,
    y1: 176.498,
    x2: 209.615,
    y2: 215.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1176_13344",
    x1: 209.519,
    y1: 182.76,
    x2: 200.25,
    y2: 160.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1176_13344",
    x1: 209.615,
    y1: 158.231,
    x2: 209.615,
    y2: 181.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1176_13344",
    x1: 209.615,
    y1: 158.568,
    x2: 209.615,
    y2: 197.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1176_13344",
    x1: 209.615,
    y1: 158.568,
    x2: 209.615,
    y2: 197.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1176_13344",
    x1: 209.519,
    y1: 164.831,
    x2: 200.25,
    y2: 142.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1176_13344",
    x1: 209.615,
    y1: 140.302,
    x2: 209.615,
    y2: 163.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1176_13344",
    x1: 209.615,
    y1: 140.639,
    x2: 209.615,
    y2: 179.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1176_13344",
    x1: 209.615,
    y1: 140.639,
    x2: 209.615,
    y2: 179.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1176_13344",
    x1: 209.519,
    y1: 146.902,
    x2: 200.25,
    y2: 124.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1176_13344",
    x1: 209.615,
    y1: 122.372,
    x2: 209.615,
    y2: 145.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1176_13344",
    x1: 209.615,
    y1: 122.709,
    x2: 209.615,
    y2: 161.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1176_13344",
    x1: 209.615,
    y1: 122.709,
    x2: 209.615,
    y2: 161.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1176_13344",
    x1: 209.519,
    y1: 128.972,
    x2: 200.25,
    y2: 106.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1176_13344",
    x1: 209.615,
    y1: 104.443,
    x2: 209.615,
    y2: 127.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1176_13344",
    x1: 209.615,
    y1: 104.78,
    x2: 209.615,
    y2: 143.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1176_13344",
    x1: 209.615,
    y1: 104.78,
    x2: 209.615,
    y2: 143.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1176_13344",
    x1: 209.519,
    y1: 111.043,
    x2: 200.25,
    y2: 88.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1176_13344",
    x1: 209.615,
    y1: 86.5138,
    x2: 209.615,
    y2: 109.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1176_13344",
    x1: 209.615,
    y1: 86.8505,
    x2: 209.615,
    y2: 125.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1176_13344",
    x1: 209.615,
    y1: 86.8505,
    x2: 209.615,
    y2: 125.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1176_13344",
    x1: 209.519,
    y1: 93.1138,
    x2: 200.25,
    y2: 70.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1176_13344",
    x1: 209.615,
    y1: 68.5844,
    x2: 209.615,
    y2: 91.8304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1176_13344",
    x1: 209.615,
    y1: 68.9216,
    x2: 209.615,
    y2: 108.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1176_13344",
    x1: 209.615,
    y1: 68.9216,
    x2: 209.615,
    y2: 108.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1176_13344",
    x1: 209.519,
    y1: 75.1844,
    x2: 200.25,
    y2: 52.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1176_13344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.8971 103.609) scale(168.127 168.127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3386,
    stopColor: "#47B071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5502,
    stopColor: "#3FA870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#309B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#1C8869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1176_13344",
    x1: 67.051,
    y1: 181.396,
    x2: 61.6652,
    y2: 349.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1176_13344",
    x1: 116.079,
    y1: 214.469,
    x2: 140.019,
    y2: 305.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1176_13344",
    x1: 190.15,
    y1: 212.675,
    x2: 181.372,
    y2: 325.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1176_13344",
    x1: 117.141,
    y1: 146.972,
    x2: 4.62681,
    y2: -54.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1176_13344",
    x1: 195.627,
    y1: 185.913,
    x2: 53.0502,
    y2: 105.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1176_13344",
    x1: 112.483,
    y1: 122.793,
    x2: 190.58,
    y2: 190.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1876,
    stopColor: "#FDBF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4837,
    stopColor: "#F7A848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#ED835B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1176_13344",
    x1: 119.81,
    y1: -7.05873,
    x2: 146.143,
    y2: 48.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3386,
    stopColor: "#47B071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5502,
    stopColor: "#3FA870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#309B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#1C8869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1176_13344",
    x1: 128.459,
    y1: 22.3216,
    x2: 163.969,
    y2: 77.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1176_13344",
    x1: 130.2,
    y1: 2.35816,
    x2: 131.995,
    y2: 20.0132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1176_13344",
    x1: 122.409,
    y1: 24.0832,
    x2: 54.4814,
    y2: 22.8864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1176_13344",
    x1: 128.821,
    y1: 44.1596,
    x2: 128.821,
    y2: 52.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1876,
    stopColor: "#FDBF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4837,
    stopColor: "#F7A848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#ED835B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1176_13344",
    x1: 122.254,
    y1: 201.244,
    x2: 69.5881,
    y2: 196.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1176_13344",
    x1: 44.3848,
    y1: 236.94,
    x2: 44.3848,
    y2: 260.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1176_13344",
    x1: 44.3848,
    y1: 237.277,
    x2: 44.3848,
    y2: 276.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1176_13344",
    x1: 44.3847,
    y1: 237.277,
    x2: 44.3847,
    y2: 276.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1176_13344",
    x1: 44.2881,
    y1: 243.54,
    x2: 35.0191,
    y2: 221.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1176_13344",
    x1: 44.3848,
    y1: 219.011,
    x2: 44.3848,
    y2: 242.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1176_13344",
    x1: 44.3848,
    y1: 219.348,
    x2: 44.3848,
    y2: 258.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1176_13344",
    x1: 44.3847,
    y1: 219.348,
    x2: 44.3847,
    y2: 258.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1176_13344",
    x1: 44.2881,
    y1: 225.611,
    x2: 35.0191,
    y2: 203.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1176_13344",
    x1: 44.3848,
    y1: 201.081,
    x2: 44.3848,
    y2: 224.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1176_13344",
    x1: 44.3848,
    y1: 201.419,
    x2: 44.3848,
    y2: 240.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1176_13344",
    x1: 44.3847,
    y1: 201.419,
    x2: 44.3847,
    y2: 240.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1176_13344",
    x1: 44.2881,
    y1: 207.681,
    x2: 35.0191,
    y2: 185.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1176_13344",
    x1: 44.3848,
    y1: 183.152,
    x2: 44.3848,
    y2: 206.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1176_13344",
    x1: 44.3848,
    y1: 183.489,
    x2: 44.3848,
    y2: 222.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1176_13344",
    x1: 44.3847,
    y1: 183.489,
    x2: 44.3847,
    y2: 222.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1176_13344",
    x1: 44.2881,
    y1: 189.752,
    x2: 35.0191,
    y2: 167.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1176_13344",
    x1: 44.3848,
    y1: 165.223,
    x2: 44.3848,
    y2: 188.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1176_13344",
    x1: 44.3848,
    y1: 165.56,
    x2: 44.3848,
    y2: 204.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1176_13344",
    x1: 44.3847,
    y1: 165.56,
    x2: 44.3847,
    y2: 204.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1176_13344",
    x1: 44.2881,
    y1: 171.823,
    x2: 35.0191,
    y2: 149.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1176_13344",
    x1: 44.3848,
    y1: 147.294,
    x2: 44.3848,
    y2: 170.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1176_13344",
    x1: 44.3848,
    y1: 147.63,
    x2: 44.3848,
    y2: 186.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1176_13344",
    x1: 44.3847,
    y1: 147.63,
    x2: 44.3847,
    y2: 186.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1176_13344",
    x1: 44.2881,
    y1: 153.894,
    x2: 35.0191,
    y2: 131.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1176_13344",
    x1: 190.98,
    y1: 236.94,
    x2: 190.98,
    y2: 260.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1176_13344",
    x1: 190.98,
    y1: 237.277,
    x2: 190.98,
    y2: 276.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1176_13344",
    x1: 190.98,
    y1: 237.277,
    x2: 190.98,
    y2: 276.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1176_13344",
    x1: 190.884,
    y1: 243.54,
    x2: 181.615,
    y2: 221.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1176_13344",
    x1: 190.98,
    y1: 219.011,
    x2: 190.98,
    y2: 242.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1176_13344",
    x1: 190.98,
    y1: 219.348,
    x2: 190.98,
    y2: 258.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1176_13344",
    x1: 190.98,
    y1: 219.348,
    x2: 190.98,
    y2: 258.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1176_13344",
    x1: 190.884,
    y1: 225.611,
    x2: 181.615,
    y2: 203.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1176_13344",
    x1: 18.0897,
    y1: 92.8699,
    x2: 41.6159,
    y2: 124.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1176_13344",
    x1: 56.1562,
    y1: 28.5827,
    x2: 72.793,
    y2: 50.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1176_13344",
    x1: 199.773,
    y1: 40.8757,
    x2: 216.41,
    y2: 63.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_13344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 254,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDashboard);
export default __webpack_public_path__ + "static/media/student-dashboard.93963734f769d8a657b563b5d4b29600.svg";
export { ForwardRef as ReactComponent };